import { c as _c } from "react/compiler-runtime";
import './nav-bag.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { getVisibleCartItems } from '@sola/cart-sdk/cart.ts';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { getFeatureFlags, getPublicConfig } from '@sola/config/lib/getters.ts';
import { useCartDrawer } from '../../contexts/cart-drawer.tsx';
import { cartDrawerFocusTargetProps } from '../cart-drawer/cart-drawer.constants.ts';
const NavBagContents: React.FC<{
  displayCount: number | string | false;
}> = t0 => {
  const $ = _c(5);
  const {
    displayCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArkIcon iconName="shopping-bag-02" className="NavBag__icon" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== displayCount) {
    t2 = displayCount ? <span className="NavBag__count label-sm label-potent flex justify-center items-center aspect-ratio-1 absolute">{displayCount}</span> : null;
    $[1] = displayCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const NavBag: React.FC<{
  /** Marks the single persistent header control used for drawer focus return. */
  isCartDrawerFocusTarget?: boolean;
}> = t0 => {
  const $ = _c(28);
  const {
    isCartDrawerFocusTarget: t1
  } = t0;
  const isCartDrawerFocusTarget = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["priority"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const {
    openCartDrawer,
    prefetchCartDrawer
  } = useCartDrawer();
  const {
    enableHeaderCartDrawer
  } = getFeatureFlags();
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getPublicConfig();
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    NEXT_PUBLIC_BASE_URL_CHECKOUT: checkoutBaseUrl
  } = t3;
  const {
    actions: t4,
    cart,
    isReady: cartIsReady
  } = useCart("actions", "cart", "isReady");
  const {
    getCart
  } = t4;
  let t5;
  if ($[2] !== cart?.items || $[3] !== cartIsReady) {
    t5 = cartIsReady ? getVisibleCartItems(cart?.items ?? []).length : 0;
    $[2] = cart?.items;
    $[3] = cartIsReady;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const count = t5;
  const displayCount = count && count > 9 ? "9+" : count;
  let t6;
  if ($[5] !== getCart) {
    t6 = () => {
      getCart();
    };
    $[5] = getCart;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  useEffect(t6, t7);
  let t8;
  if ($[8] !== t) {
    t8 = t("header.cart");
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const title = t8;
  if (!enableHeaderCartDrawer) {
    const t9 = cart?.checkoutUrl || checkoutBaseUrl;
    let t10;
    if ($[10] !== displayCount) {
      t10 = <NavBagContents displayCount={displayCount} />;
      $[10] = displayCount;
      $[11] = t10;
    } else {
      t10 = $[11];
    }
    let t11;
    if ($[12] !== t10 || $[13] !== t9 || $[14] !== title) {
      t11 = <Link className="NavBag flex p-comfy-xs relative" href={t9} title={title} aria-label={title}>{t10}</Link>;
      $[12] = t10;
      $[13] = t9;
      $[14] = title;
      $[15] = t11;
    } else {
      t11 = $[15];
    }
    return t11;
  }
  let t9;
  if ($[16] !== isCartDrawerFocusTarget) {
    t9 = isCartDrawerFocusTarget ? cartDrawerFocusTargetProps : {};
    $[16] = isCartDrawerFocusTarget;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== openCartDrawer) {
    t10 = () => openCartDrawer();
    $[18] = openCartDrawer;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== displayCount) {
    t11 = <NavBagContents displayCount={displayCount} />;
    $[20] = displayCount;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== prefetchCartDrawer || $[23] !== t10 || $[24] !== t11 || $[25] !== t9 || $[26] !== title) {
    t12 = <button {...t9} type="button" className="NavBag p-comfy-xs relative" aria-label={title} onClick={t10} onPointerEnter={prefetchCartDrawer} onFocus={prefetchCartDrawer}>{t11}</button>;
    $[22] = prefetchCartDrawer;
    $[23] = t10;
    $[24] = t11;
    $[25] = t9;
    $[26] = title;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};